<template>
  <div class="cc-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'cc-card',

  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
.cc-card {
  box-shadow: $box-shadow-base;
  background: #fff;
  // margin-bottom: 8px;
  padding: 0 10px;
}
</style>
